export const CountryConfigToken = {
  ICountryConfigRepository: Symbol("ICountryConfigRepo"),
  CountryConfigUseCase: Symbol("CountryConfigUseCase"),
  CountryConfigViewModel: Symbol("CountryConfigViewModel"),
};
